import React, { useEffect, useState } from "react";
import {
  Button,
  FormCheckList,
  Input,
  Loading,
  Modal,
  SelectWithFiltering,
} from "../../elements/_Elements";
import { ButtonStyle, LoadingState } from "../../../js/enums";
import { Create } from "../../../js/service";
import {
  getAttributesForSave,
  getLookupInState,
  handleRedirect,
} from "../Helpers";
import { useGlobalReducer } from "../../../GlobalContext";
import { useFormReducer } from "../FormContext";
import { getEntityNameAttribute } from "../../../js/utility";
import lookups from "../../../forms/lookups";
import { getDataFromStateLookupOrServices } from "./Helpers";

function ProductCopy({
  entityName,
  setDisplayRecordCopyModal,
  stages,
  state,
  values,
}) {
  const [isCopying, setIsCopying] = useState(false);
  const [loading, setLoading] = useState(LoadingState.NotLoaded);
  const [categoryData, setCategoryData] = useState(null);
  const [channelData, setChannelData] = useState(null);
  const [groupData, setGroupData] = useState(null);
  const [widgetGroupData, setWidgetGroupData] = useState(null);
  const [productGroupData, setProductGroupData] = useState(null);

  const [initialLoad, setInitialLoad] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(
    state.g4b_categoryid
  );
  const [selectedChannels, setSelectedChannels] = useState(
    state.g4b_channel || []
  );
  const [selectedGroups, setSelectedGroups] = useState(
    state.g4_group || []
  );
  const [selectedWidgetGroups, setSelectedWidgetGroups] = useState(
    state.g4b_widgetgroup || []
  );
  const [selectedProductGroups, setSelectedProductGroups] = useState(
    state.g4b_productgroup || []
  );

  const [newProductRecordName, setNewProductRecordName] =
    useState("");
  const [newProductRecordCode, setNewProductRecordCode] =
    useState("");
  const [
    newProductRecordDescription,
    setNewProductRecordDescription,
  ] = useState("");
  const [newProductRecordSequence, setNewProductRecordSequence] =
    useState("");
  const globalDispatch = useGlobalReducer();
  const dispatch = useFormReducer();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getDataFromStateLookupOrServices(
          globalDispatch,
          [
            {
              entityName: "g4b_analysiscategory",
              lookupOptions: getLookupInState(
                state,
                lookups.g4b_analysiscategory.all
              ),
              setData: setCategoryData,
            },
            {
              entityName: "g4b_channel",
              lookupOptions: getLookupInState(
                state,
                lookups.g4b_channel.all
              ),
              setData: setChannelData,
            },
            {
              entityName: "g4_group",
              lookupOptions: getLookupInState(
                state,
                lookups.g4_group.widget
              ),
              setData: setGroupData,
              searchFilter: "22",
            },
            {
              entityName: "g4b_widgetgroup",
              lookupOptions: getLookupInState(
                state,
                lookups.g4b_widgetgroup.all
              ),
              setData: setWidgetGroupData,
            },
            {
              entityName: "g4b_productgroup",
              lookupOptions: getLookupInState(
                state,
                lookups.g4b_productgroup.all
              ),
              setData: setProductGroupData,
            },
          ],
          setLoading,
          setInitialLoad
        );
      } catch (error) {
        console.error(error);
      }
    };

    if (initialLoad) {
      fetchData();
    }
  }, [globalDispatch, initialLoad, state]);

  const copyProductRecord = async () => {
    let response = null;
    setIsCopying(true);
    try {
      const successMessage = `${newProductRecordName} successfully created`;
      let attributes = getAttributesForSave(null, stages, {
        ...state,
        ...values,
      });
      let nameAttribute = getEntityNameAttribute(entityName);
      attributes[nameAttribute] = newProductRecordName;
      attributes["g4b_code"] = newProductRecordCode;
      attributes["g4b_description"] = newProductRecordDescription;
      attributes["g4b_sequence"] = newProductRecordSequence;
      attributes["g4b_categoryid"] = selectedCategory;
      attributes["g4b_channel"] = selectedChannels;
      attributes["g4_group"] = selectedGroups;
      attributes["g4b_widgetgroup"] = selectedWidgetGroups;
      attributes["g4b_productgroup"] = selectedProductGroups;
      attributes["g4b_reportname"] =
        newProductRecordName.toUpperCase();
      attributes["g4b_zone"] = [];
      attributes["productVariants"] = [];
      attributes["g4b_mandatoryvariants"] = false;
      attributes["primaryImage"] = null;
      const [serviceResponse] = await Promise.all([
        Create(
          globalDispatch,
          successMessage,
          {
            Id: state.id,
            Name: newProductRecordName,
            Attributes: attributes,
          },
          entityName
        ),
      ]);
      response = serviceResponse.data;
    } catch (error) {
      console.error(error);
    } finally {
      setIsCopying(false);
      if (response && response.Id) {
        // result is the id and we redirect to the page for it
        handleRedirect(null, dispatch, response.Id, "copyRecord");
      } else {
        console.error("Invalid response returned.");
      }
    }
  };

  return (
    <>
      <Modal
        title={"Copy Product Record"}
        modalCloseButtonClick={() => setDisplayRecordCopyModal(null)}
        className="modal modal-dialog-scrollable modal-fullscreen"
      >
        {loading !== LoadingState.Loaded ? (
          <Loading />
        ) : (
          <>
            <div className="modal-body">
              <small>
                {"Enter values for the new product record"}
              </small>
              <Input
                className={"mb-3"}
                label={"Name"}
                mandatory={true}
                name={"NewProductRecordName"}
                onChange={(event) =>
                  setNewProductRecordName(event.target.value)
                }
                value={newProductRecordName}
              />
              <div className="row mb-3">
                <div className="col-md-6">
                  <Input
                    label={"Code"}
                    name={"NewProductRecordCode"}
                    onChange={(event) =>
                      setNewProductRecordCode(event.target.value)
                    }
                    value={newProductRecordCode}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label={"Sequence"}
                    type={"int"}
                    name={"NewProductRecordSequence"}
                    onChange={(event) =>
                      setNewProductRecordSequence(event.target.value)
                    }
                    value={newProductRecordSequence}
                  />
                </div>
              </div>
              <Input
                className={"mb-3"}
                label={"Description"}
                name={"NewProductRecordDescription"}
                onChange={(event) =>
                  setNewProductRecordDescription(event.target.value)
                }
                value={newProductRecordDescription}
              />
              {categoryData && categoryData.length > 0 && (
                <SelectWithFiltering
                  className={"mb-3"}
                  label={"Category"}
                  mandatory={true}
                  name={"NewProductRecordCategory"}
                  options={categoryData}
                  onChange={(event) =>
                    setSelectedCategory(event.value)
                  }
                  value={selectedCategory}
                />
              )}
              {channelData && channelData.length > 0 && (
                <FormCheckList
                  className={"mb-3"}
                  label={"Sales channels"}
                  name={"NewProductRecordChannels"}
                  inline={true}
                  onChange={(event) =>
                    setSelectedChannels(
                      event.target.checked
                        ? [...selectedChannels, event.target.value]
                        : selectedChannels.filter(
                            (id) => id !== event.target.value
                          )
                    )
                  }
                  options={channelData}
                  value={selectedChannels}
                />
              )}
              {groupData && groupData.length > 0 && (
                <FormCheckList
                  className={"mb-3"}
                  label={"Groups"}
                  name={"NewProductRecordGroups"}
                  inline={true}
                  onChange={(event) =>
                    setSelectedGroups(
                      event.target.checked
                        ? [...selectedGroups, event.target.value]
                        : selectedGroups.filter(
                            (id) => id !== event.target.value
                          )
                    )
                  }
                  options={groupData}
                  value={selectedGroups}
                />
              )}
              {widgetGroupData && widgetGroupData.length > 0 && (
                <FormCheckList
                  className={"mb-3"}
                  label={"Widget Groups"}
                  name={"NewProductRecordWidgetGroups"}
                  inline={true}
                  onChange={(event) =>
                    setSelectedWidgetGroups(
                      event.target.checked
                        ? [
                            ...selectedWidgetGroups,
                            event.target.value,
                          ]
                        : selectedWidgetGroups.filter(
                            (id) => id !== event.target.value
                          )
                    )
                  }
                  options={widgetGroupData}
                  value={selectedWidgetGroups}
                />
              )}
              {productGroupData && productGroupData.length > 0 && (
                <FormCheckList
                  className={"mb-3"}
                  label={"Product Groups"}
                  name={"NewProductRecordProductGroups"}
                  inline={true}
                  onChange={(event) =>
                    setSelectedProductGroups(
                      event.target.checked
                        ? [
                            ...selectedProductGroups,
                            event.target.value,
                          ]
                        : selectedProductGroups.filter(
                            (id) => id !== event.target.value
                          )
                    )
                  }
                  options={productGroupData}
                  value={selectedProductGroups}
                />
              )}
            </div>
            <div className="modal-footer">
              <Button
                text={"Confirm"}
                style={ButtonStyle.Primary}
                onClick={() => copyProductRecord()}
                showSpinner={isCopying}
                disabled={
                  !newProductRecordName ||
                  newProductRecordName.trim() === "" ||
                  isCopying
                }
              />
              <Button
                text={"Cancel"}
                style={ButtonStyle.Info}
                onClick={() => setDisplayRecordCopyModal(null)}
                showSpinner={isCopying}
                disabled={isCopying}
              />
            </div>
          </>
        )}
      </Modal>
    </>
  );
}

export default ProductCopy;
